import React from 'react';
import Link from '../../link';
import './index.css';

export default function ExtraButton({link, img, text}) {
  return (
    <div className="banner-extra--button">
      {link ? (
        <Link to={link}>
          <img alt="" src={img} />
        </Link>
      ) : (
        <div className="banner-extra--button-image">
          <img alt="" src={img} />
        </div>
      )}
      <div>{text}</div>
    </div>
  );
}
